// extracted by mini-css-extract-plugin
export default {"Spinner":"loadingspinner_Spinner__in7rg","spin":"loadingspinner_spin__iKAJ7"};